import { useCurrentUserAccessRole } from "Hooks/useCurrentUserAccessRole";
import { AccessRoleCodes } from "Models/AccessRoleCodes";

// The one place that says which roles count as a hunter; use it wherever the role is already at hand.
export const isHunter = (userRole: string | null | undefined) =>
  userRole === AccessRoleCodes.Hunter ||
  userRole === AccessRoleCodes.HunterPlus;

export const useIsCurrentUserHunter = () => {
  const userRole = useCurrentUserAccessRole();

  return isHunter(userRole);
};
